import { useMutation } from '@tanstack/react-query';
import { markMaterialView } from '../queries/materials';

export function useFinishMaterial() {
  const { mutate, isPending, isSuccess } = useMutation({
    mutationKey: ['finish-material-from-card'],
    mutationFn: (slug: string) => markMaterialView(slug),
    retry: false
  });

  return { mutate, isPending, isSuccess };
}